import { Service } from 'core/types/service';

import { Action, SET_CUSTOMER_SERVICES } from './actions';

interface CutsomerServicesState {
  [key: string]: Array<Service & { pivot: { price: number } }>;
}

export default (
  state: CutsomerServicesState = {},
  action: Action
): CutsomerServicesState => {
  switch (action.type) {
    case SET_CUSTOMER_SERVICES:
      return { ...state, [action.payload.customer]: action.payload.services };
    default:
      return state;
  }
};
